import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Toaster from "../../Components/Toaster";
import {
  Box,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Buttons from "../../Components/Button/Buttons";
import {
  resetPassword,
  forgotPasswordreset,
} from "../../../serviceFile/ApiService";

const ResetPassword = () => {
  const [newPasswordErr, setNewPasswordErr] = useState(""); // state used to maintain errors
  const [newPassword, setNewPassword] = useState(""); // state used for store vendor code
  const [confirmPassErr, setConfirmPassErr] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isSmDown = useMediaQuery("(max-width: 600px)");
  const isForgotPassword = searchParams.get("isForgetPassword");

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((showConfirmPassword) => !showConfirmPassword);

  // change password function
  const handleSubmit = () => {
    let flag = 0;
    const Vcode = localStorage.getItem("vendorCode");
    if (newPassword.trim().length === 0) {
      setNewPasswordErr("Password is required");
      flag = 1;
    }
    if (confirmPassword.trim().length === 0) {
      setConfirmPassErr("Confirm Password is required");
      flag = 1;
    }
    if (newPassword !== confirmPassword) {
      setConfirmPassErr("Passwords do not match");
      flag = 1;
    }
    if (newPasswordErr !== "" || confirmPassErr !== "") {
      return;
    }
    if (flag === 0) {
      const body = {
        password: newPassword,
        vendor_code: Vcode,
      };
      if (isForgotPassword) {
        forgotPasswordreset(body)
          .then((res) => {
            const errorMessage = res?.data?.message;
            if (res?.data?.status === 404) {
              Toaster(errorMessage, 134, ["error"]);
            } else {
              Toaster("Password reset completed", 1, ["success"]);
              localStorage.clear();
              navigate("/", { replace: true });
            }
          })
          .catch((err) => {
            const errorMessage = err?.response?.data?.message;
            if (err?.response?.data?.status === 404) {
              Toaster(errorMessage, 134, ["error"]);
            } else {
              Toaster("Sorry something went wrong!", 134, ["error"]);
            }
          });
      } else {
        resetPassword(body)
          .then((res) => {
            const errorMessage = res?.data?.message;
            if (res?.data?.status === 404) {
              Toaster(errorMessage, 134, ["error"]);
            } else {
              localStorage.clear();
              Toaster("Registration completed successfully", 1, ["success"]);
              navigate("/", { replace: true });
            }
          })
          .catch((err) => {
            const errorMessage = err?.response?.data?.message;
            if (err?.response?.data?.status === 404) {
              Toaster(errorMessage, 134, ["error"]);
            } else {
              Toaster("Sorry something went wrong!", 134, ["error"]);
            }
          });
      }
    }
  };

  // function to handle new password validations
  const handleNewPassword = (e) => {
    const newPasswordValue = e?.target?.value;
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{8,}$/;

    setNewPassword(e.target.value);
    if (newPassword === confirmPassword) {
      setConfirmPassErr("");
    }
    if (newPasswordValue === null || newPasswordValue === "")
      setNewPasswordErr("Password is required");
    else if (newPasswordValue.trim().length === 0) {
      setNewPasswordErr("Password is required");
    } else if (!regex.test(newPasswordValue)) {
      setNewPasswordErr("Please enter a valid password");
    } else if (newPasswordValue.trim().length > 16) {
      setNewPasswordErr("Maximum password length is 16");
    } else if (newPasswordValue.trim().length < 8) {
      setNewPasswordErr("Password minimum length is 8");
    } else {
      setNewPasswordErr("");
      setNewPassword(e.target.value);
    }
  };

  // function to handle confirm password
  const handlePassword = (e) => {
    const passwordValue = e?.target?.value;
    setConfirmPassword(e.target.value);
    if (passwordValue === null || passwordValue === "")
      setConfirmPassErr("Confirm password is required");
    else if (passwordValue.trim().length === 0) {
      setConfirmPassErr("Confirm password is required");
    } else {
      setConfirmPassErr("");
      setConfirmPassword(e.target.value);
    }
  };

  function checkChar() {
    const trimmedPassword = newPassword?.replace(/\s/g, "");
    return trimmedPassword?.length >= 8 && trimmedPassword?.length <= 16;
  }

  function checkLower() {
    let reg = /[a-z]/;
    return reg.test(newPassword);
  }

  function checkUpper() {
    let reg = /[A-Z]/;
    return reg.test(newPassword);
  }

  function checkNumber() {
    let reg = /\d/;
    return reg.test(newPassword);
  }

  function checkSpecialCharacter() {
    let reg = /[!@#~`$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
    return reg.test(newPassword);
  }

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Stack direction={isSmDown ? "column" : "row"}>
        <Stack width={isSmDown ? "100%" : "50%"}>
          <Stack
            direction="column"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "98%"
            }}
            spacing={1}
            // sx={{ width: "98%" }}
          >
            <img
              src="/assets/images/password-lock.avif"
              alt="logo"
              style={{ width: "300px", height: "200px" }}
            ></img>
            <Typography
              variant="subtitle1"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "brown",
              }}
            >
              <Typography component="ul">
                <Typography
                  component="li"
                  style={
                    checkChar()
                      ? {
                          transition: "0.4s",
                          color: "green",
                          fontWeight: 600,
                        }
                      : { color: "brown", transition: "0.4s", fontWeight: 600 }
                  }
                >
                  Password must contain 8 to 16 characters
                </Typography>
                <Typography
                  component="li"
                  style={
                    checkUpper()
                      ? {
                          transition: "0.4s",
                          color: "green",
                          fontWeight: 600,
                        }
                      : { color: "brown", transition: "0.4s", fontWeight: 600 }
                  }
                >
                  At least one capital letter (A-Z){" "}
                </Typography>
                <Typography
                  component="li"
                  style={
                    checkLower()
                      ? {
                          transition: "0.4s",
                          color: "green",
                          fontWeight: 600,
                        }
                      : { color: "brown", transition: "0.4s", fontWeight: 600 }
                  }
                >
                  At least one small letter (a-z)
                </Typography>
                <Typography
                  component="li"
                  style={
                    checkNumber()
                      ? {
                          transition: "0.4s",
                          color: "green",
                          fontWeight: 600,
                        }
                      : { color: "brown", transition: "0.4s", fontWeight: 600 }
                  }
                >
                  At least one number (0-9)
                </Typography>
                <Typography
                  component="li"
                  style={
                    checkSpecialCharacter()
                      ? {
                          transition: "0.4s",
                          color: "green",
                          fontWeight: 600,
                        }
                      : { color: "brown", transition: "0.4s", fontWeight: 600 }
                  }
                >
                  At least one special character
                </Typography>
              </Typography>
            </Typography>
          </Stack>
        </Stack>
        <Stack
          width={isSmDown ? "100%" : "50%"}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column" spacing={2} sx={{ width: "70%" }}>
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "darkslategray",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
            >
              Set Password
            </Typography>
            <TextField
              id="outlined-basic"
              label="New password"
              variant="outlined"
              autoComplete="off"
              type={showPassword ? "text" : "password"}
              size="medium"
              margin="dense"
              error={!!newPasswordErr}
              helperText={newPasswordErr}
              sx={{ width: { xs: "300px", sm: "300px" } }}
              onChange={(e) => handleNewPassword(e)}
              InputProps={{
                shrink: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon style={{ color: "rgb(242, 200, 35) " }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOff style={{ color: "rgb(0,0,139)" }} />
                      ) : (
                        <Visibility style={{ color: "rgb(64, 132, 255) " }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              id="outlined-password-input"
              label="Confirm password"
              variant="outlined"
              type={showConfirmPassword ? "text" : "password"}
              autoComplete="current-password"
              onChange={handlePassword}
              sx={{ width: { xs: "300px", sm: "300px" } }}
              error={!!confirmPassErr}
              helperText={confirmPassErr}
              InputProps={{
                shrink: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon style={{ color: "rgb(242, 200, 35) " }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff style={{ color: "rgb(0,0,139)" }} />
                      ) : (
                        <Visibility style={{ color: "rgb(64, 132, 255) " }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Buttons
              onClick={handleSubmit}
              sx={{
                width: { xs: "300px", sm: "300px" },
                height: 35,
              }}
              text="Save password"
            />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ResetPassword;
